@if (!isLoading()) {
    <div class="stats-card" [class.dark]="variant() === 'dark'" [style.height]="height()">
        <div class="stats-card__top">
            <div class="stats-card__header">
                @if (statsData()?.iconKey) {
                    <div
                        class="stats-card__icon-container"
                        [style.background-color]="statsData()?.customColor?.bgColor">
                        <svg
                            class="stats-card__icon"
                            width="14"
                            height="14"
                            [style.color]="statsData()?.customColor?.iconColor">
                            <use [attr.href]="spritePath + '#' + statsData()?.iconKey"></use>
                        </svg>
                    </div>
                }
                <div class="stats-card__info">
                    <h3 class="stats-card__title">{{ statsData()?.title }}</h3>
                    <p class="stats-card__description">{{ statsData()?.description }}</p>
                </div>
            </div>
            @if (statsData()?.total && hasTotal() && totalPosition() === 'top-right') {
                <div class="stats-card__total">
                    <span class="stats-card__number">{{ statsData()?.total }}</span>
                </div>
            }
        </div>

        <div class="stats-card__content">
            @if (hasTotal() && totalPosition() === 'bottom-left') {
                <p class="stats-card__number bottom-left">{{ statsData()?.total }}</p>
            }
            <div
                class="stats-card__content--stats"
                [class.fullWidth]="(hasTotal() && totalPosition() === 'top-right') || !hasTotal()"
                [class.dark]="variant() === 'dark'">
                @for (stat of statsData()?.stats; track $index) {
                    @if (stat.variant === 'trend') {
                        <div class="trend">
                            <span class="trend__label">{{ stat.label }}</span>
                            <div
                                class="trend__badge"
                                [class]="
                                    hasColorClass(stat)
                                        ? stat.trend?.colorClass
                                        : ($safeNavigationMigration(stat.trend?.value)!
                                          | colorClass)
                                ">
                                @if (stat.trend?.value === 'up') {
                                    <svg class="trend__icon" width="24" height="24">
                                        <use href="/assetsh/icons/icons-sprite.svg#trend-up"></use>
                                    </svg>
                                } @else {
                                    <svg class="trend__icon" width="24" height="24">
                                        <use href="/assets/icons/icons-sprite.svg#trend-down"></use>
                                    </svg>
                                }
                                <span class="trend__value">{{ formatValue(stat.value) }}</span>
                            </div>
                        </div>
                    } @else {
                        <div class="normal">
                            @if (reverseStatPosition()) {
                                <span class="normal__value" [class]="stat.colorClass">{{
                                    stat.value
                                }}</span>
                                <span class="normal__label" [style.color]="stat.labelColor">{{
                                    stat.label
                                }}</span>
                            } @else {
                                <span class="normal__label" [style.color]="stat.labelColor">{{
                                    stat.label
                                }}</span>
                                <span class="normal__value" [class]="stat.colorClass">{{
                                    stat.value
                                }}</span>
                            }
                        </div>
                    }
                }
            </div>
        </div>
    </div>
} @else {
    <!-- Skeleton indicator -->
    <div class="stats-card-skeleton">
        <ntv-skeleton width="100%" height="126px" borderRadius="20px" />
    </div>
}
